import './Footer.css';
import logo from "../image/logo.svg";

function Footer() {
    return (
        <div className="about-us-bottom">
            <div className='about-us-bottom-left'>
                <img className='about-us-bottom-logo' alt='error-img' src={logo}/>
            </div>
            <div className="about-us-bottom-middle">
                <div className="about-us-bottom-middle-name">Nebular Antivirus</div>
                <div className="about-us-bottom-middle-phone-number">Business address: 1771 Robson Street
                    Vancouver, BC, Canada, V6G 3B7
                </div>
                <div className="about-us-bottom-middle-phone-number">Phone Number: +1 423 451 6288</div>
            </div>
            <div className="about-us-bottom-right">
                <div className="about-us-bottom-right-words">All rights reserved © 2023 Nebular Binary Software Inc.
                </div>
            </div>
        </div>
    );
}

export default Footer